import React from 'react';
import PropTypes from 'prop-types';
import { withScriptjs, withGoogleMap, Marker, InfoWindow, GoogleMap as Map } from 'react-google-maps';
import Loader from '../Loader';
var GoogleMap = withScriptjs(withGoogleMap(function (props) {
  return React.createElement(Map, props);
}));
GoogleMap.Marker = Marker;
GoogleMap.InfoWindow = InfoWindow; // See https://tomchentw.github.io/react-google-maps/#googlemap for more props

GoogleMap.propTypes = {
  defaultZoom: PropTypes.number,
  defaultCenter: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number
  }),
  googleMapURL: PropTypes.string,
  loadingElement: PropTypes.node,
  containerElement: PropTypes.node,
  mapElement: PropTypes.node
};
GoogleMap.defaultProps = {
  defaultZoom: 12,
  defaultCenter: {
    lat: 42.3601,
    lng: -71.0589
  },
  // Boston, MA
  googleMapURL: 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places',
  loadingElement: React.createElement(Loader, null, "Loading Google Maps"),
  containerElement: React.createElement("div", {
    style: {
      height: '400px'
    }
  }),
  mapElement: React.createElement("div", {
    style: {
      height: '100%'
    }
  })
};
export default GoogleMap;